import React from "react";


const Wrap = ({children})=>{
    return(
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default Wrap;